
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import axios from "axios";
import apiUrl from "../../environment/Api";
import "../../assets/css/NewPromotion.css";
import { toast } from "react-toastify";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";

const modules = {
  toolbar: [
    [{ header: "1" }, { header: "2" }, { font: [] }],
    [{ size: [] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ indent: "-1" }, { indent: "+1" }],
    [{ align: [] }],
    [{ color: [] }, { background: [] }],
    ["link", "image", "video"],
    ["clean"],
  ],
};

const formats = [
  "header",
  "font",
  "size",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
  "image",
  "video",
  "color",
  "background",
  "align",
];

function FullFeaturedEditor() {
  const [editorContent, setEditorContent] = useState("");
  const [selectedRoute, setSelectedRoute] = useState("contact_leads");
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [file, setFile] = useState(null);

  const handleEditorChange = (value) => {
    setEditorContent(value);
  };

  const handleRouteChange = (e) => {
    const route = e.target.value;
    setSelectedRoute(route);
    fetchData(route);
  };

  const fetchData = async (route) => {
    try {
      setLoading(true);
      let apiRoute = "";
      if (route === "contact_leads") {
        apiRoute = "/contact_leads";
      } else if (route === "student") {
        apiRoute = "/student";
      } else if (route === "student_completed") {
        apiRoute = "/student_completed";
      } else if (route === "Enquiry") {
        apiRoute = "/leads";
      } else if (route === "Student_Datebase") {
        apiRoute = "/internship";
      } else if (route === "Recruting_Partner") {
        apiRoute = "/recruting_partner";
      } else if (route === "Skill_Development") {
        apiRoute = "/internship_student";
      }

      // const response = await axios.get(`${apiUrl}${apiRoute}`);   

      const response = await axios.get(`${apiUrl}${apiRoute}`, {
        params: { branch_id: localStorage.getItem("branch_id") }
      });

      console.log(`${route} data:`, response.data);
      setResponseData(response.data);
    } catch (error) {
      console.log("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };




  const handleSendEmail = async (e) => {
    e.preventDefault();

    // Validate fields before sending
    if (!selectedRoute || !title || !message) {
      alert('Please fill all fields');
      return;
    }

    try {
      const response = await axios.post(`${apiUrl}/send_mail`, {
        selectedRoute,
        title,
        message
        // file: file // Include if handling file uploads
      }, {
        headers: {
          'Content-Type': 'application/json',
          // 'Authorization': `Bearer ${token}` // If using auth
        }
      });

      console.log('Saved successfully:', response.data);
      return response.data;

    } catch (error) {
      console.error('Error:', error.response?.data || error.message);
      throw error;
    }
  };


  // const handleSendEmail = async () => {
  //   try {

  //     // const formData = new FormData();
  //     // formData.append("title", title);
  //     // formData.append("message", message);
  //     // formData.append("file", file);
  //     // formData.append("selectedRoute", selectedRoute);

  //     // // Send emails to the selected group
  //     // const response = await axios.post(`${apiUrl}/send_mail`, formData, {
  //     //   headers: { "Content-Type": "multipart/form-data" },
  //     // });

  //     const formData = new FormData();
  //     formData.append("title", title);
  //     formData.append("message", message);
  //     formData.append("file", file);
  //     formData.append("selectedRoute", selectedRoute);

  //     const response = await axios.post(apiUrl + `/send_mail`, formData, {
  //       headers: { "Content-Type": "multipart/form-data" },
  //     });

  //     if (response.status === 200) {
  //       setResponseData((prevData) =>
  //         prevData.map((item) => ({ ...item, status: "Sent" }))
  //       );
  //     }
  //     toast.success("Successfully Sending Mail");
  //   } catch (error) {
  //     console.log("Error sending email:", error);
  //     toast.error("Mail Cannot Send")
  //     setResponseData((prevData) =>
  //       prevData.map((item) => ({ ...item, status: "Unsent" }))
  //     );
  //   }
  // };

  useEffect(() => {
    fetchData(selectedRoute);
  }, [selectedRoute]);





  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  // Pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = responseData.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Search
  const filtered = currentItems.filter((item) =>
    Object.values(item).some(
      (value) =>
        typeof value === "string" &&
        value.toLowerCase().includes(searchQuery.toLowerCase()) ||
        (typeof value === "number" && value.toString().includes(searchQuery))
    )
  );

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const totalPages = Math.ceil(responseData.length / itemsPerPage);

  const goToNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage === totalPages ? prevPage : prevPage + 1
    );
  };

  const goToPrevPage = () => {
    setCurrentPage((prevPage) => (prevPage === 1 ? prevPage : prevPage - 1));
  };
  // the pagination  end ----------------------------------------------------------------


  const createPagination = () => {
    let liTag = [];
    let beforePage = currentPage - 1;
    let afterPage = currentPage + 1;
    let active;

    if (currentPage > 1) {
      liTag.push(
        <li className="page-item" key="prev">
          <button
            className="page-link"
            onClick={() => paginate(currentPage - 1)}
          >
            <FaAngleLeft /> Prev
          </button>
        </li>
      );
    }

    if (currentPage > 2) {
      liTag.push(
        <li className="page-item" key="first" onClick={() => paginate(1)}>
          <button className="page-link">1</button>
        </li>
      );
      if (currentPage > 3) {
        liTag.push(
          <li className="page-item disabled" key="dots1">
            <span className="page-link">...</span>
          </li>
        );
      }
    }

    if (currentPage === totalPages) {
      beforePage -= 2;
    } else if (currentPage === totalPages - 1) {
      beforePage -= 1;
    }

    if (currentPage === 1) {
      afterPage += 2;
    } else if (currentPage === 2) {
      afterPage += 1;
    }

    for (let plength = beforePage; plength <= afterPage; plength++) {
      if (plength > totalPages || plength <= 0) continue;
      active = currentPage === plength ? "active" : "";
      liTag.push(
        <li
          className={`page-item ${active}`}
          key={plength}
          onClick={() => paginate(plength)}
        >
          <button className="page-link">{plength}</button>
        </li>
      );
    }

    if (currentPage < totalPages - 1) {
      if (currentPage < totalPages - 2) {
        liTag.push(
          <li className="page-item disabled" key="dots2">
            <span className="page-link">...</span>
          </li>
        );
      }
      liTag.push(
        <li
          className="page-item"
          key="last"
          onClick={() => paginate(totalPages)}
        >
          <button className="page-link">{totalPages}</button>
        </li>
      );
    }

    if (currentPage < totalPages) {
      liTag.push(
        <li className="page-item" key="next">
          <button
            className="page-link"
            onClick={() => paginate(currentPage + 1)}
          >
            Next <FaAngleRight />
          </button>
        </li>
      );
    }

    return liTag;
  };







  return (
    <>
      <div style={{ marginTop: "-80px" }}>
        <div className="row mb-3">
          <div className="col-lg-11">
            <Link to="/dashboard" className="text-secondary dashBoard_text">
              <b>Dashboard / </b>
            </Link>
            <Link to="" className="text-danger dashBoard_text">
              <b>New Promotions</b>
            </Link>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-9 d-flex">
          <h5 className="mt-2">New Promotions</h5>
        </div>
      </div>

      <div>
        <h2>Full-Featured Text Editor</h2>
        <ReactQuill
          theme="snow"
          value={editorContent}
          onChange={handleEditorChange}
          modules={modules}
          formats={formats}
          placeholder="Write something amazing..."
        />
        <h3>Editor Output:</h3>
        <div
          dangerouslySetInnerHTML={{ __html: editorContent }}
          style={{ width: "100px", height: "10px" }}
        />
      </div>

      <div className="container mt-5">
        <div className="row mt-3">
          <div className="col-lg-4">
            <div className="card p-3">
              <div className="row mb-2">
                <div className="col-lg-12">
                  <h5 className="text-center">To Mail</h5>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-lg-4">
                  <label>Title</label>
                </div>
                <div className="col-lg-8">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Enter title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                  />
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-lg-4">
                  <label>Message</label>
                </div>
                <div className="col-lg-8">
                  <textarea
                    className="form-control"
                    rows="4"
                    placeholder="Enter message"
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                  ></textarea>
                </div>
              </div>
              <div className="row mb-2">
                <div className="col-lg-4">
                  <label>Image</label>
                </div>
                <div className="col-lg-8">
                  <input
                    type="file"
                    className="form-control"
                    onChange={(e) => setFile(e.target.files[0])}
                  />
                </div>
              </div>
              <div className="row mt-3 mb-2 text-center">
                <div className="col-lg-6">
                  <button className="btn btn-primary" onClick={handleSendEmail}>
                    Send
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="col-lg-8">
            <div className="mb-1 mt-1">
              <div className="row">
                <div className="col-lg-3 col-md-4 col-sm-4 d-flex mt-4">
                  <label className='form-label text-dark mt-2'>Show:</label>
                  <div>
                    <select className="form-control w-100 mx-2" onChange={(e) => { setItemsPerPage(e.target.value) }}>
                      <option value='5'>5</option>
                      <option value='10'>10</option>
                      <option value='20'>20</option>
                      <option value='50'>50</option>
                    </select>
                  </div>
                </div>
                <div className="col-lg-6 col-md-4 col-sm-1 ">
                  <h5>Select:</h5>
                  <div className="col-lg-10 mb-2">
                    <select
                      className="form-control"
                      value={selectedRoute}
                      onChange={(e) => setSelectedRoute(e.target.value)}
                    >
                      <option value="contact_leads">Contact Leads</option>
                      <option value="student">Studying Students</option>
                      <option value="student_completed">Completed Students</option>
                      <option value="Enquiry">Enquiry</option>
                      <option value="Student_Datebase">Student Database</option>
                      <option value="Recruting_Partner">Recruting Partner</option>
                      {/* <option value="Skill_Development">Skill Development</option> */}
                      {localStorage.getItem("branch_id") == "null" && (
                        <option value="Skill_Development">Skill Development</option>
                      )}
                    </select>
                  </div>

                </div>
                <div className="col-lg-3 col-md-4 col-sm-7 mt-4">

                  <div className="w-full flex-1">
                    <form>
                      <div className="relative">

                        <input
                          className="form-control w-full bg-white  appearance-none pl-8  dark:bg-gray-950"
                          placeholder="Search ..."
                          type="search"
                          value={searchQuery}
                          onChange={handleSearchChange}
                        />

                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row">
              <div className="col-lg-8 text-end mt-1">
                <h5>Select:</h5>
              </div>
              <div className="col-lg-4 mb-2">
                <select
                  className="form-control"
                  value={selectedRoute}
                  onChange={handleRouteChange}
                >
                  <option value="contact_leads">Contact Leads</option>
                  <option value="student">Students</option>
                  <option value="student_completed">Completed Students</option>
                </select>
              </div>
            </div> */}

            <table className="table table-striped border">
              <thead>
                <tr>
                  <th>S.No</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map((item, index) => (
                  <tr key={item._id}>
                    <td>{index + 1}</td>
                    <td>{item.visitor_staff || item.student_name_lead || item.student_name || item.full_name || item.FacultyName}</td>
                    <td>{item.email || item.email_lead || item.email_address || item.official_email}</td>
                    <td>{item.status || ""}</td>
                  </tr>
                ))}
              </tbody>
            </table>


            <div className="mt-3 pb-5">
              <div className="row">
                <div className="col-lg-7 col-sm-12 mt-1">
                  <span className="text-dark">
                    Page {currentPage} of {totalPages}
                  </span>
                </div>
                <div className="col-lg-5">
                  <nav>
                    <ul className="pagination justify-content-center">
                      {createPagination()}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>


          </div>


        </div>
      </div>
    </>
  );
}

export default FullFeaturedEditor;
